import * as React from 'react';
import { connect } from 'react-redux';
import { BasePage } from '../reusableComponents/BasePage';
import { InputField } from '../reusableComponents/FormComponents/InputField';
import { FormFooter } from '../reusableComponents/FormComponents/FormFooter';
import { Form } from '../reusableComponents/FormComponents/Form';
import './profile.scss';
import { isFormEmpty } from '../../utils/generalUtils';
import { withRouter } from 'react-router';
import { IHistory } from '../../interfaces';
import { submitUserFeedback } from '../../services/userService';

export interface IUserFeedbackProps {
    userId: string;
    history: IHistory;
}

export class UserFeedbackImpl extends React.PureComponent<IUserFeedbackProps, {}> {
    constructor(props: IUserFeedbackProps) {
        super(props);
    }

    public handleSubmit = async (value) => {
        if (isFormEmpty(value)) {
            return;
        }
        await submitUserFeedback(value.feedback, this.props.userId, this.props.history);
      }

    public render() {
        return <BasePage baseClassName="user-feedback" icon="comments" title="User Feedback">
            <Form model="forms.feedback" onSubmit={this.handleSubmit}>
                <InputField
                    id="feedback"
                    key={1}
                    hintText=""
                    label="Comments:"
                    type="text"
                    required
                    model=".feedback"
                />
                <FormFooter
                    // submitLabel="Submit"
                />
            </Form>
        </BasePage>;
    }
}
export function mapStateToProps(state, ownProps) {
    return {
        userId: ownProps.match.params.id
    };
}
export const UserFeedback = withRouter(connect<{}, {}, IUserFeedbackProps>(mapStateToProps)(UserFeedbackImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Profile/UserFeedback.tsx